/*                              @Author : {}
 * Copyright (c) 2021, by Tush Entertainment
 * Permission to use, copy, modify or distribute this software in binary or source form
 * for any purpose is allowed only under explicit prior consent in writing from Tush Entertainment.
 * THE SOFTWARE IS PROVIDED "AS IS" AND TUSH ENTERTAINMENT DISCLAIMS
 * ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL TUSH ENTERTAINMENT
 * BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
 * DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
 * PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
 * ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
 * SOFTWARE.THIS SOFTWARE IS PROTECTED BY COPYRIGHT LAWS FROM INDIA AND USA.
 * ANY OR ALL PART OF THIS SOFTWARE OR SOURCES CANNOT BE USED FOR ANY TYPES OF
 * PRODUCTS WHICH IS DIRECTLY AND INDIRECTLY AFFECTING THE LIFE OF HUMANS.
 */

import React, { useEffect, useState} from "react";
// import {
//   AreaChart,
//   Area,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
// } from "recharts";
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Spin from "../Spinner/Spin";
import { LoadingContext } from "../Dashboard";
//const { loading } = useContext(LoadingContext);
const LineChart = ({subscriptionData,loading}) => {
  let navigate = useNavigate();
  const [labels, setlabel] = useState([]);
  const [type, settype] = useState("subscription");
  const [periods, setperiod] = useState("week");
  const [title, settitle] = useState("");
  const [val, setval] = useState();
  const [listperiod, setlist] = useState([]);

  const [showSubscription, setShowSubscription] = useState(true);
  const [data,setData]=useState([])

  const [flag, setflag] = useState(false);
  const calc = (res) => {
    var sum = 0;
    var sum_i = 0;
    for (var i = 0; i < res.length; i++) {
      var add = sum + res[i].count;
      sum = add;
    }
  };
  const toggleSubscription = () => {
    setShowSubscription(!showSubscription);
  };
  return (
       <div className='graphsme'>
        <div className='graphsme01'>
          <p>
            <h5>Subscription Data</h5>
            <span onClick={toggleSubscription}>{showSubscription ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon/>}</span>
          </p>
          {showSubscription && subscriptionData && !loading ?
            <div className='graphsme02'>
              <p>
                <span>Today's Subscription count:&nbsp;</span>
                <b>
                  {subscriptionData.todaySubscription && subscriptionData.todaySubscription[0]
                    ? subscriptionData.todaySubscription[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Yesterday's Subscription count:&nbsp;</span>
                <b>
                  {subscriptionData.yesterdaySubscription && subscriptionData.yesterdaySubscription[0]
                    ? subscriptionData.yesterdaySubscription[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Weekly Subscription count:&nbsp;</span>
                <b>
                  {subscriptionData.weeklySubscription && subscriptionData.weeklySubscription[0]
                    ? subscriptionData.weeklySubscription[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Biweekly Subscription count:&nbsp;</span>
                <b>
                  {subscriptionData.biweeklySubscription && subscriptionData.biweeklySubscription[0]
                    ? subscriptionData.biweeklySubscription[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Monthly Subscription count:&nbsp;</span>
                <b>
                  {subscriptionData.monthlySubscription && subscriptionData.monthlySubscription[0]
                    ? subscriptionData.monthlySubscription[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Quarterly Subscription count:&nbsp;</span>
                <b>
                  {subscriptionData.quarterlySubscription && subscriptionData.quarterlySubscription[0]
                    ? subscriptionData.quarterlySubscription[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Annual Subscription count:&nbsp;</span>
                <b>
                  {subscriptionData.annualSubscription && subscriptionData.annualSubscription[0]
                    ? subscriptionData.annualSubscription[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Life Subscription count:&nbsp;</span>
                <b>
                  {subscriptionData.lifeSubscription && subscriptionData.lifeSubscription[0]
                    ? subscriptionData.lifeSubscription[0].count
                    : "NA"}
                </b>
              </p>
            </div>:
             <div className="spindefault">
             <Spin/>
             </div>
          }
        </div>
      </div>
  );
};
export default LineChart;

// import React,{useEffect,useState} from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from 'chart.js';
// import { Line } from 'react-chartjs-2';
// import AsyncSelect from 'react-select/async';
// import sampler from '../../Objects/axiosjson';
// import { Opt , Listperiod} from '../../Objects/Country';

// const LineChart = () => {

//   let navigate = useNavigate();
// const [labels,setlabel]=useState([])
// const [type,settype]=useState('subscription')
// const [periods,setperiod]=useState('week')
// const [title,settitle]=useState('')
// const[val,setval]=useState()
// const [listperiod,setlist]=useState([])

// const opt=async()=>{
//   return Opt();
// }
// useEffect(()=>{
//   const ff = Listperiod();
//   setlist(ff)
// },[])

// useEffect(()=>{
// exec()
// return null
// },[periods])

// const exec=()=>{
//   const params= {
//     "type":type,
//     "periods":periods
//     }

// sampler.post('/getChartData',params)
// .then(res =>{
//   if(res.data.error === false){
//     let result = [{totalAmount:'',count:'',date:''}];
//     result = res.data.data;
//     calc(result)
//     setlabel(result.map(x=> { return x.date}))
//     setval(result.map(x=>{return x.count } ))
//     const upper = periods.toUpperCase();
//     settitle(upper)
//   }

// }).catch(err=>{
//   console.log(err.response)
//   {/*if(err.response.status === 403){
//     localStorage.clear();
//     navigate('/login/error?message=session token expired please login again !')
//   }*/}
// })
// }
// const handle=(x)=>{
//   setperiod(x)

// }
// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Legend
//   );
//     const options = {
//         responsive: true,
//         plugins: {
//           legend: {
//             position: 'bottom',
//           }

//         },
//       };

//       const data = {
//         labels ,
//         datasets: [
//           {
//             label: 'Total Subscriptions',
//             data: val,
//             borderColor: '#e24585',
//             backgroundColor: '#e24585',
//           },

//         ],
//       };
//       const[selectvalue,setselectvalue]=useState({label:'Graph'});
//       const[flag,setflag]=useState(false)

//       const handleopt=(e)=>{
//         setselectvalue(e)
//         console.log(e.label);
//         if(e.label === 'Data' ){
//           setflag(true)
//         }
//         else if(e.label === 'Graph'){
//           setflag(false)
//         }
//         else{

//         }
//       }

//       const [subs,setsubs]=useState('')
//       const [amount,setamount]=useState('')
// const calc= (res) =>{
//   var sum = 0;
//   var sum_i = 0;
//   for(var i=0; i<res.length;i++){
//     var add = sum + res[i].count
//     sum = add;
//   }
//         setsubs(sum)
//         for (var j=0;j<res.length;j++){
//           var add1 = sum_i + res[j].totalAmount
//           sum_i = add1
//         }
//         setamount(sum_i)
//       }
//   return (
//     <>
//           <div className='container-fluid p-0 m-0 graph'>
//             <div className='head bg-light'>
//               <div className='row'>
//               <div className='col-md-6'>
//                 <p><i className="fa fa-cube" ></i> Subscriptions</p>
//                 <p style={{'padding':'0 5px 0 32px','fontSize':'14px'}}>showing result for <b>{title}</b></p>
//                </div>

//               <div className='col-md-6'>
//                 {!flag ?
//                 <div>
//                 <span>Y-Axis - number of Subscriptions</span><br/>
//                 <span>X-Axis - Time / Date / Month</span>
//                 </div>
//                 :''}

//               </div>
//               </div>
//             </div>

//             <div className='row'>
//             <div className='col-md-9 bg-light rounded'>
//            {!flag ?
//            <Line
//             height={240}
//             data={data} options={options}/>
//             :
//             <div className='data'>
//               <p>Subscriptions : {subs}</p>
//               {/*<p>Total Collection : {amount} &#x20B9; </p>*/}

//             </div>
//             }
//            </div>
//            <div className='col-md-3 bg-light rounded p-1'>

//            <AsyncSelect
//                         cacheOptions
//                         defaultOptions
//                         className='drop'
//                         value={selectvalue}
//                         defaultValue={selectvalue}
//                         getOptionLabel={e => e.label}
//                         getOptionValue={e => e.label}
//                         loadOptions={opt}
//                         onChange={handleopt}
//                     />
//             <div className='Paper mt-2'>
//               {listperiod.map((x,index)=>{
//                 return(
//                   <li key={index}>{x.icon}<span onClick={()=> handle(x.value)}>{x.Name}</span></li>
//                 )
//               })}
//             </div>
//            </div>

//             </div>

//           </div>

//     </>

//   )
// }

// export default LineChart;
